import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import BottomNav from "@/components/BottomNav";
import Splash from "@/pages/Splash";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Lesson from "@/pages/Lesson";
import VoicePractice from "@/pages/VoicePractice";
import Tutor from "@/pages/Tutor";
import MathPractice from "@/pages/MathPractice";
import Progress from "@/pages/Progress";
import Teacher from "@/pages/Teacher";
import Creator from "@/pages/Creator";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" data-testid="protected-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check to handle OAuth callback before ProtectedRoute runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Splash />} />
      <Route path="/splash" element={<Splash />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/onboarding" element={<OnboardingGate />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/lesson/:id" element={<Protected><Lesson /></Protected>} />
      <Route path="/voice" element={<Protected><VoicePractice /></Protected>} />
      <Route path="/tutor" element={<Protected><Tutor /></Protected>} />
      <Route path="/math" element={<Protected><MathPractice /></Protected>} />
      <Route path="/progress" element={<Protected><Progress /></Protected>} />
      <Route path="/teacher" element={<Protected><Teacher /></Protected>} />
      <Route path="/creator/*" element={<Protected><Creator /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function OnboardingGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Onboarding />;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <BottomNav />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
